export const drawerMobileBreakpoint = 700

const europeanUnionBlockCode = 'EU'

export const europeanUnionBlock = {
  code: europeanUnionBlockCode,
  name: null,
  isEuropeanUnion: true,
  showCustomsCode: true,
  showExportPrice: false,
  showManufacturer: false,
}
